import React from 'react'
import { InfoSec, InfoRow, InfoImg } from './InformacoesCompra.elements'
import { Container } from '../../globalStyles'

import img1 from '../../images/Parcelamento-01.svg'
import img2 from '../../images/Pix-02.svg'
import img3 from '../../images/Garantia-03.svg'
import img4 from '../../images/Frete-04.svg'

const InformacoesCompra = () => {
  return (
    <InfoSec>
      <Container>
        <InfoRow>
          <InfoImg src={img1} alt="Parcelamento no cartão" />
          {
            //<InfoImg src={img2} />
            }
          <InfoImg src={img3} alt="Garantia de 7 dias" />
          <InfoImg src={img4} alt="Frete grátis" />
        </InfoRow>
      </Container>
    </InfoSec>
  )
}

export default InformacoesCompra
